import React from "react";
import { Outlet } from "react-router-dom";

const SubjectRouter = () => {
  return <Outlet />;
};

export default SubjectRouter;
